import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const EditPatientIcon = () => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M7.29545 9.54545C9.10364 9.54545 10.5682 8.08091 10.5682 6.27273C10.5682 4.46455 9.10364 3 7.29545 3C5.48727 3 4.02273 4.46455 4.02273 6.27273C4.02273 8.08091 5.48727 9.54545 7.29545 9.54545ZM7.29545 4.63636C8.19546 4.63636 8.93182 5.37273 8.93182 6.27273C8.93182 7.17273 8.19546 7.90909 7.29545 7.90909C6.39545 7.90909 5.65909 7.17273 5.65909 6.27273C5.65909 5.37273 6.39545 4.63636 7.29545 4.63636ZM12.5236 11.64C11.1491 10.9364 9.36546 10.3636 7.29545 10.3636C5.22545 10.3636 3.44182 10.9364 2.06727 11.64C1.24909 12.0573 0.75 12.9 0.75 13.8164V16.0909H13.8409V13.8164C13.8409 12.9 13.3418 12.0573 12.5236 11.64ZM12.2045 14.4545H2.38636V13.8164C2.38636 13.5055 2.55 13.2273 2.81182 13.0964C3.78545 12.5973 5.35636 12 7.29545 12C9.23455 12 10.8055 12.5973 11.7791 13.0964C12.0409 13.2273 12.2045 13.5055 12.2045 13.8164V14.4545Z"
        fill={getThemeColor("icon-color")}
      />
      <path
        d="M16.3842 3.81818C16.299 3.81818 16.2103 3.85227 16.1456 3.91704L15.5217 4.5409L16.8001 5.81931L17.424 5.19545C17.5569 5.06249 17.5569 4.84772 17.424 4.71477L16.6262 3.91704C16.5581 3.84886 16.4728 3.81818 16.3842 3.81818ZM15.1569 4.90568L11.3865 8.67613V9.95454H12.6649L16.4353 6.18408L15.1569 4.90568Z"
        fill={getThemeColor("icon-color")}
      />
    </svg>
  );
};

export default EditPatientIcon;
